export default "__VITE_ASSET__B77S1Oko__"